import React from 'react'
import { Route, BrowserRouter as Router, Routes, Link, NavLink } from 'react-router-dom';
import { IntrigrationLeftSec } from '../components/intrigrationLeftSec';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import ScrollToTop from "react-scroll-to-top";
import config from '../Config';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export const AutomatedInvoiceModify=() =>
{
    const exampleCodeText_3=`<input type="button" value="submit"  onClick="TCBPayProxynizationAPI.process('#creditcard_number','tcbpayClientCallback');" />`;
    const exampleCodeText_4=`<form name="" id="formID" action="https://gateway2-stg.tcbpay.com/apis/update-invoice.php" method="post"> 
<input type="text" name="username" value="tcbpayusername"/> 
<input type="text" name="api_key" value="tcbpayapikey"/> 
<input type="text" name="invoice_id" value="jSJk687687V"/> 
<input type="text" name="mid" id="mid" value="1234567890"/> 
<input type="checkbox" name="is_draft" value="0"/> 
<input type="text" name="invoice_no" value="Is001"/> 
<input type="text" name="send_date" value="12/15/2025"/> 
<input type="text" name="due_date" value="12/18/2025"/> 
<input type="text" name="items" value='[{"desc":"Item 1","price":"10.00"},{"desc":"Item 2","price":"20.00"}]'/> 
<input type="text" name="tax_rate" value="14.5"/> 
<input type="text" name="discount_rate" value="14.5"/> 
<input type="text" name="amount" value="14.5"/> 
<input type="text" name="currency" value="USD"/> 
<input type="text" name="company" value="TCB Pay"/> 
<input type="text" name="first_name" value="Roberto"/> 
<input type="text" name="last_name" value="Diaz"/> 
<input type="text" name="email" value="abcdef@mail.com"/> 
<input type="text" name="address" value="4446 Green Avenue, Suite 56"/> 
<input type="text" name="city" value="Los Angeles"/> 
<input type="text" name="state" value="CA"/> 
<input type="text" name="country" value="US"/> 
<input type="text" name="zip" value="11111"/> 
<input type="text" name="phone" value="+11111111111"/> 
<input type="checkbox" name="ship_address_as_bill_address" value="0"/> 
<input type="text" name="ship_first_name" value="Roberto"/> 
<input type="text" name="ship_last_name" value="Diaz"/> 
<input type="text" name="ship_address" value="4446 Green Avenue, Suite 56"/> 
<input type="text" name="ship_city" value="Los Angeles"/> 
<input type="text" name="ship_state" value="CA"/> 
<input type="text" name="ship_country" value="US"/> 
<input type="text" name="ship_zip" value="11111"/> 
<input type="text" name="ship_phone" value="+11111111111"/> 
<input type="text" name="ship_company" value="TCB Pay"/> 
<input type="text" name="ship_amount" value="14.5"/> 
<input type="text" name="is_recurring" value="1"/>
<input type="text" name="interval_type" value="2"/>
<input type="text" name="day_of_month" value="30"/>
<input type="text" name="period_type" value="MONTHLY"/>
<input type="text" name="charge_type" value="1"/>
<input type="text" name="charge_date" value="01/16/2026"/>
<br/> 
<input type="submit" value="submit" /> 
</form> 
`;
    const exampleCodeText_5=`{
	"message": "User successfully created.",
    "code": 00,
	"data": { 
		"user_uid": "{Unique ID of user}",
		"activation_code": "{Unique activation code needed to activate user}",
"first_name": "firstname", 
"last_name": "lastname", 
"email": "example@example.com", 
"phone_number": "4071234567", 
"employee_number": "999999999", 
"shipping_address1": "123 example street", 
"shipping_address2": "apt 123", 
"shipping_city": "example", 
"shipping_state": "TX", 
"shipping_zip": "12345", 
"billing_address1": "123 example street", 
"billing_address2": "apt 123", 
"billing_city": "example", 
"billing_state": "TX", 
"billing_zip": "12345" 
"created_date": "2024-12-03 14:25:00", 
}
}`;

    const exampleCodeText_6=`{
	"api_username": "{Unique api username}",
	"api_key": "{Unique api_key}",
	"user_uid": "{Unique id of user to be modified}"
	"phone_number": "4071234567"
	"billing_address_type": "N",
	"billing_address1": "123 example street", 
	"billing_address2": "apt 123", 
	"billing_city": "example",
	"billing_state": "TX",
	"billing_zip": "12345",
}`;
    const exampleCodeText_7=`{
	"message": "User successfully modified.",
	"code": 00,
	"data": { 
"user_uid": "{Unique id of user}", 
"first_name": "firstname", 
"last_name": "lastname", 
"user_type": "user",
"email": "example@example.com", 
"phone_number": "4071234567", 
"employee_number": "999999999", 
"shipping_address1": "123 example street", 
"shipping_address2": "apt 123", 
"shipping_city": "example", 
"shipping_state": "TX", 
"shipping_zip": "12345", 
"billing_address_type": "N",
	"billing_address1": "123 example street", 
	"billing_address2": "apt 123", 
	"billing_city": "example",
	"billing_state": "TX",
	"billing_zip": "12345",
	"modified_date": "2024-01-01 23:59:59"
}
}`;

    const exampleCodeText_8=`{
	"api_username": "{Unique api username}",
	"api_key": "{Unique api_key}",
"status":"DELETE",
"user_uid": "{Unique id of user}"
}`;
    const exampleCodeText_9=`{
"message": "User status successfully changed.",
"code": 00,
	"user_uid": "{Unique id of user}"
"status":"DELETED",
	"deleted_date": "2024-01-01 23:59:59",.
}`;

    const exampleCodeText_10=`{
	"message": "Users successfully received.",
	"code": 00,
	"current_page": 1,
	"total_pages": 1,
	"total_record_count": 1,
	"data": {
       	"users": [
        {
       "user_details": { 
		"user_uid": "{Unique id of user}",
"first_name": "firstname", 
"last_name": "lastname", 
"email": "example@example.com", 
"phone_number": "4071234567", 
"user_type": "USER",
"employee_number": "999999999", 
"shipping_address1": "123 example street", 
"shipping_address2": "apt 123", 
"shipping_city": "example", 
"shipping_state": "TX", 
"shipping_zip": "12345", 
"billing_address1": "123 example street", 
"billing_address2": "apt 123", 
"billing_city": "example", 
"billing_state": "TX", 
"billing_zip": "12345" 
"status": "active",
"created_date": "2024-01-01 23:59:59",
"modified_date": "2024-01-01 23:59:59",
"deleted_date": "2024-01-01 23:59:59",
"is_deleted": "1"
}
}
      	]
	}
}`;
    const exampleCodeText_11=`{
  "api_username": "{Unique api username}",
  "api_key": "{Unique api_key}",
 "user_access_uid": "{unique id of user}"
  "card_uid": [
	"{unique id of card}",
	"{unique id of card}",
	"{unique id of card}"
  ],
  "user_uid": [
	"{unique id of user}",
	"{unique id of user}"
  ],
  "operation_type": "Add"
}`;

    const exampleCodeText_12=`{
  "message": "Access list successfully modified",
  "code": 00,
  "cards": [
	"{unique id of card}",
	"{unique id of card}",
	"{unique id of card}"
  ],
  "users": [
	"{unique id of user}",
	"{unique id of user}"
  ]
}`;

    const exampleCodeText_13=`{ "message": "Access list successfully recieved",
  "code": 00,
  "cards": [
	"{unique id of card}",
	"{unique id of card}",
	"{unique id of card}"
  ],
  "users": [
	"{unique id of user}",
	"{unique id of user}"
  ]
}`;

    const onCopy=React.useCallback( ( id: number ) =>
    {
        const element=document.getElementById( "myTooltip"+id );
        if ( element )
        {
            element.classList.add( "show" );
            const intervalId=setInterval( () =>
            {
                element.classList.remove( "show" );
                clearInterval( intervalId );
            }, 2000 );
        }
    }, [] );

    return (
        <section className="credit-api-main">
            <img src={ `${ config.siteBaseUrl }/assets/imgs/our-integrations-bg.svg` } alt="" className='apibg' />
            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <IntrigrationLeftSec />
                    </div>
                    <div className="col-lg-9">
                        <div className="creadit-api-upper-wrapper">
                            <Link to="/integrations" className='apidetail-btn'><FontAwesomeIcon icon={ faArrowRight } /> Return to Integrations page</Link>
                        </div>

                        <div className="creadit-api-lower-wrapper">
                            <div className="api-menu-item-title"><h1>Invoice API Documentation</h1></div>

                            <div className="api-menu-item-wrapper">
                                <h3>Update Automated Invoice API</h3>
                                <p>This API is responsible for updating new automated invoice.</p>
                                <hr />
                                <ul className="card-url">
                                    <li>
                                        <div className="card-url-list">
                                            <p>Name of API:</p>
                                            <span>Update Automated Invoice API</span>
                                        </div>

                                    </li>
                                    <li>
                                        <div className="card-url-list">
                                            <p>Description:</p>
                                            <span>This API is responsible for updating new automated invoice.</span>
                                        </div>

                                    </li>
                                    <li>
                                        <div className="card-url-list">
                                            <p>URL:</p>
                                            <span>https://portal.tcbpay.com/apis/update-automated-invoice-status.php</span>
                                        </div>

                                    </li>

                                    <li>
                                        <div className="card-url-list">
                                            <p>Sandbox endpoint URL:</p>
                                            <span>https://gateway2-stg.tcbpay.com/apis/update-automated-invoice-status.php</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="card-url-list">
                                            <p>Method:</p>
                                            <span>POST</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="api-table">
                                <h5>JSON Body Parameters:</h5>
                                <p>This table describes the request parameters for Modify Invoice API</p>

                                <div className="table-responsive">
                                    <table summary="This table describes the request parameters for Modify Invoice API" className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th style={ { width: '100px' } }>Variable Name</th>
                                                <th style={ { width: '420px' } }>Description</th>
                                                <th style={ { width: '100px' } }>Required</th>
                                                <th style={ { width: '130px' } }>Expected Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>username</td>
                                                <td>TCB Pay Gateway Username</td>
                                                <td>Yes</td>
                                                <td>TCB Pay Gateway Username</td>
                                            </tr>

                                            <tr>
                                                <td>api_key</td>
                                                <td>TCB Pay Gateway API Key</td>
                                                <td>Yes</td>
                                                <td>TCB Pay Gateway API Key</td>
                                            </tr>

                                            <tr>
                                                <td>recurring_id</td>
                                                <td>Automated invoice id</td>
                                                <td>Yes</td>
                                                <td>0a113ef6b61820daa5611c870ed8d5ee</td>
                                            </tr>

                                            <tr>
                                                <td>status</td>
                                                <td>Status of the invoice to be updated</td>
                                                <td>Yes</td>
                                                <td>Allowed status: PAUSE, CANCEL, DELETE</td>
                                            </tr>

                                            <tr>
                                                <td>paused_date_until</td>
                                                <td>Until when the invoice will be paused</td>
                                                <td>Y (if status = PAUSE)</td>
                                                <td>
                                                    02/16/2026 (allowed format: mm/dd/yyyy)
                                                </td>
                                            </tr>
                                        </tbody>


                                    </table>
                                </div>

                                {/* <div className="example-box-wrapper">
                                    <div className="d-flex align-items-start">
                                        <b></b>
                                        <p><span>Example</span></p>
                                    </div>
                                    <div className="example-box">
                                        <div className="example-box-top">
                                            <div className="tooltip1" id="myTooltip4">
                                                <span className="tooltiptext">Copied</span>
                                            </div>
                                            <CopyToClipboard onCopy={ () => onCopy( 4 ) } text={ exampleCodeText_4 }>
                                                <FontAwesomeIcon icon={ faCopy } />
                                            </CopyToClipboard>

                                            <FontAwesomeIcon icon={ faUpRightAndDownLeftFromCenter } />

                                        </div>

                                        <div className="ex-text-box" id="ExampleCodeText_4">
                                            <pre>{ exampleCodeText_4 }</pre>
                                        </div>

                                    </div>
                                </div> */}
                            </div>



                            <div className="api-menu-item-wrapper mt-60">
                                <h3>Response</h3>
                                <hr />
                                <p>The response of the API Call is a JSON array. Two elements are returned, code and description. The response code for a successful API call is always 00</p>
                                <div className="d-flex align-items-start">
                                    <b></b>
                                    <p><span>Sample Response</span></p>
                                </div>
                                <code>{ '{"response":{"code":"00","description":"Automated Invoice paused/cancelled/deleted successfully"}}' }</code>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
            <img src={ `${ config.siteBaseUrl }/assets/imgs/blue-lowerdots.svg` } alt="" className="orng-dots" />
            <ScrollToTop smooth />
        </section>
    )
}
